import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Grid } from "semantic-ui-react";
import Loading from "../app/loading";
import RetailerList from "./retailer_list";
import Retailer from "./retailer";

const Admin = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const retailerParam = query.get("retailer");
  const newRetailerParam = query.get("add");
  const searchParams = location.search;

  const retailers = useSelector((state) => state.retailers);
  const [showLoading, setShowLoading] = useState(true);
  const [retailer, setRetailer] = useState(null);

  useEffect(() => {
    if (retailers.length) {
      setShowLoading(false);
    }
  }, [retailers]);

  useEffect(() => {
    if (retailerParam) {
      const r = retailers.find((item) => {
        return item.name === retailerParam;
      });
      setRetailer(r);
    }
  }, [retailers, retailerParam]);

  useEffect(() => {
    if (newRetailerParam === "new") {
      setRetailer({});
    }
  }, [newRetailerParam]);

  useEffect(() => {
    if (!searchParams) setRetailer(null);
  }, [searchParams]);

  if (showLoading) return <Loading />;

  return (
    <Grid padded>
      <Grid.Column width={3}>
        <RetailerList retailers={retailers} />
      </Grid.Column>
      <Grid.Column width={13}>
        {retailer && <Retailer retailer={retailer} />}
      </Grid.Column>
    </Grid>
  );
};

export default Admin;
